"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var support_1 = require("./support");
exports.detectMobileOS = support_1.detectMobileOS;
exports.detectDesktopBrowser = support_1.detectDesktopBrowser;
exports.browser = support_1.browser;
exports.mobileOS = support_1.mobileOS;
exports.touch = support_1.touch;
exports.msPointers = support_1.msPointers;
exports.pointers = support_1.pointers;
exports.touchEnabled = support_1.touchEnabled;
var getter_1 = require("./accessors/getter");
exports.getter = getter_1.getter;
var setter_1 = require("./accessors/setter");
exports.setter = setter_1.setter;
var parse_style_1 = require("./parse-style");
exports.parseInlineStyles = parse_style_1.parseInlineStyles;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-common@1.0.2/~/@progress/kendo-common/dist/npm/main.js
// module id = 6407
// module chunks = 0